export default class AppConstants {
  static API_HOST =
    window?.rezziPlugin?.ajaxUrl ||
    "https://rezzilivestg.wpengine.com/wp-admin/admin-ajax.php";
  static FORMATTED_PHONE_NUMBER =
    window?.rezziPlugin?.formattedPhoneNumber || "1300 001 358";
  static PHONE_NUMBER = window?.rezziPlugin?.phoneNumber || "1300001358";
  static ADMIN_EMAIL = window?.rezziPlugin?.adminEmail || "info@rezzi.com.au";
  static BLOG_URL = window?.rezziPlugin?.blogUrl || "/blog";
  static SERVICES_URL = window?.rezziPlugin?.servicesUrl || "/services";
  static CONTACT_US_URL =
    window?.rezziPlugin?.contactUsUrl || "/contact-us/#contact-form";
  static WEBAPP_BASE_URL =
    window?.rezziPlugin?.webappBaseUrl ||
    "https://rezzilivestg.wpengine.com/wp-content/plugins/rezzi-plugin/webapp";
  static WP_METHOD = {
    NEW: "new",
    EDIT: "edit",
    DELETE: "delete",
    LIST: "list",
  };
  static QUOTE_SERVICES = {
    CONVEYANCING: "conveyancing",
    STRUCTURAL_INSPECTION: "structural_inspection",
    LP_SHOWCASE: "lp_showcase",
    DEFAULT: "",
  };
  static QUOTE_CONVEYANCING_TYPES = {
    BUYER: "buyer",
    SELLER: "seller",
    BOTH: "both",
  };
  static QUOTE_INSPECTION_TYPES = {
    STRUCTURAL: "structural",
    STRUCTURAL_MAINTENANCE: "structural_maintenance",
    TIMBER_PEST: "timber_pest",
  };
  static EXPORT_CONTACTS_TYPES = {
    CUSTOMER_DATA: "customer_data",
    COMMON_DATA: "common_data",
  };
  static MAX_PURCHASE_PRICE = parseInt(
    window?.rezziPlugin?.maxPurchasePrice || "0"
  );
  static MAX_SALE_PRICE = parseInt(window?.rezziPlugin?.maxSalePrice || "0");
  static GOOGLE_API_KEY = "AIzaSyD-7LcH6DJqDpL_HRL64BLIZUCYeGmi2H8";
}
